// extracted by mini-css-extract-plugin
export var linkList = "GlobalLinks-module--linkList--6b352";